import React from 'react'

export const CheckCircle = (props) => (
  <svg
    width="61"
    height="61"
    viewBox="0 0 61 61"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M39.8102 9.59078C35.3044 7.58313 30.2704 7.08576 25.4589 8.17286C20.6473 9.25997 16.3161 11.8733 13.1111 15.6231C9.9062 19.3729 7.99923 24.0582 7.67467 28.9804C7.35011 33.9025 8.62533 38.7977 11.3102 42.9358C13.995 47.074 17.9456 50.2334 22.5727 51.9429C27.1998 53.6524 32.2556 53.8203 36.986 52.4217C41.7163 51.0231 45.8679 48.1328 48.8214 44.182C51.775 40.2311 53.3723 35.4314 53.3751 30.4985V28.1617C53.3751 26.7579 54.513 25.62 55.9168 25.62C57.3205 25.62 58.4584 26.7579 58.4584 28.1617V30.5C58.455 36.529 56.5027 42.3968 52.8928 47.2256C49.283 52.0545 44.2088 55.587 38.4273 57.2964C32.6457 59.0059 26.4664 58.8006 20.811 56.7112C15.1557 54.6218 10.3272 50.7603 7.04572 45.7026C3.76427 40.6448 2.20566 34.6618 2.60235 28.6459C2.99904 22.63 5.32977 16.9034 9.24694 12.3203C13.1641 7.73726 18.4578 4.54319 24.3386 3.21451C30.2194 1.88583 36.3721 2.49372 41.8791 4.94752C43.1613 5.51884 43.7376 7.02141 43.1663 8.30361C42.595 9.58581 41.0924 10.1621 39.8102 9.59078ZM57.7131 8.36844C58.7061 9.36053 58.7069 10.9698 57.7148 11.9629L32.2982 37.405C31.8216 37.882 31.175 38.1502 30.5007 38.1503C29.8264 38.1505 29.1796 37.8827 28.7028 37.4059L21.0778 29.7809C20.0852 28.7883 20.0852 27.179 21.0778 26.1864C22.0704 25.1938 23.6797 25.1938 24.6723 26.1864L30.4992 32.0133L54.1186 8.37024C55.1107 7.37716 56.72 7.37635 57.7131 8.36844Z"
      fill="#578C6D"
    />
  </svg>
)
